import classNames from 'classnames';
import React from 'react';
import { Chip, ChipColor } from '../../../../../../../../../components/Chip';
import { Trend } from '../../../../../../../../../components/survey_engine/Trend';
import styles from '../../TableBody/styles.module.scss';

interface PropTypes {
  value: number;
  trend: number;
  chipColor: ChipColor;
}

export function ValueWithTrend(props: PropTypes) {
  return (
    <td className={classNames(styles['table-data-cell-border-bottom'], 'pb-4')}>
      <div className='d-flex justify-content-end align-items-center'>
        <Chip
          className={classNames('fw-semibold', 'fs-5')}
          color={props.chipColor}
        >
          {Math.round(props.value * 10) / 10}
        </Chip>
        <div className='text-end' style={{ width: '50px' }}>
          <Trend trend={Math.round(props.trend)} className={'fs-6'} />
        </div>
      </div>
    </td>
  );
}
